import axios from 'axios';
import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { FaEye, FaUserCog } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import LoadingButton from '../components/LoadingButton';
import { useGStore } from '../context/Context';
import { FETCHING_ERROR, FETCHING_OF } from '../state/actionTypes/actionTypes';

const Register = () => {
     const {state, dispatch} = useGStore()
    const [data , setData] = useState({});
    const [passShow,setPassShow] = useState(false)
    const navigation = useNavigate();
    const handleRegister = (e)=>{
        e.preventDefault();
        if(!data.name){
            return toast.error("নাম পাওয়া যাইনি")
           }
           if(!data.number){
            return toast.error("মোবাইল নাম্বার পাওয়া যাইনি")
           }
           if(!data.pass){
            return toast.error("পাসওয়ার্ড নাম্বার পাওয়া যাইনি")
           }
       if(data?.pass?.length < 6 || data.pass === "undefined"){
        return toast.error("পাসওয়ার্ড ৬ টি সংখ্যা দিতে হবে")
       }
       if(data.name || data.pass || data.number){
        axios.post(`https://amar-dish-server.vercel.app/users`,data).then(res =>{
            // console.log(res.data);
            if(res.data.message ==="Number Have Already"){
              toast.error(`এই নাম্বার ${data.number} আগে থেকেই রয়েছে`)
            }
            if(res.data.acknowledged){
              toast.success(`রেজিস্ট্রেশন সফল হয়েছে`)
              navigation(`/login`)
            }
            dispatch({type : FETCHING_OF})
          }).catch(err =>{
            dispatch({type : FETCHING_ERROR})
          })
       }
    }

    return (
     
             <div className='bg-blue-600'>
      
      <div className='h-[100vh] w-full flex items-center justify-center'>
         <div className='w-[360px] lg:w-96 h-[650px] shadow-2xl p-10 rounded-md bg-white'>
         <h1 className='text-4xl text-center  my-2'>আমার বিল</h1>
         <div className='flex items-center justify-center gap-2'>
         <FaUserCog size={24}></FaUserCog>
         <h1 className="text-2xl font-bold my-1 text-center">রেজিস্টার</h1>
         </div> 
         <div className='divider'></div>
         <form onSubmit={handleRegister} className='flex flex-col gap-4 mt-3'>
         <input type="name" onChange={(e)=>setData({...data,name : e.target.value})} placeholder="আপা নাম" className="input input-bordered w-full " />
         <input type="tel" onChange={(e)=>setData({...data,number : e.target.value})} placeholder="ঠিকানা" className="input input-bordered w-full " />
         <input type="tel" onChange={(e)=>setData({...data,number : e.target.value})} placeholder="মোবাইল নাম্বার" className="input input-bordered w-full " />
         <input type="tel" onChange={(e)=>setData({...data,number : e.target.value})} placeholder="মোবাইল নাম্বার" className="input input-bordered w-full " />
        <div className='relative'>
        <input type={passShow  ?"text" :"password" } onChange={(e)=>setData({...data,pass : e.target.value})} placeholder="পাসওয়ার্ড" className="input input-bordered w-full " />
        <button type='button' onClick={()=>setPassShow(!passShow)} className='btn btn-ghost absolute right-0 top-0'><FaEye size={24}></FaEye></button>
        </div>
        {
            state.loading ?<LoadingButton text={"পাঠিয়ে দিন"}></LoadingButton> : <input type="submit" value={"পাঠিয়ে দিন"} className="btn btn-ghost w-full " />
           }  
         </form>
         <p className='text-sm text-center'>একাউন্ট আগে থেকে থাকলে <Link className='btn btn-link p-1 text-blue-600' to="/login">লগইন করুন</Link></p>
         </div>
     </div>
    </div>
     
    );
};

export default Register;